'use client';

import { Header, Main } from '@/components';
import { APPLICATION_STORAGE_KEY } from '@/components/features/Applications/ApplicationForm/ApplicationForm.utils';
import { ApplicationFormContent } from '@/components/features/Applications/ApplicationForm/ApplicationFormContent';
import { ApplicationFormExitButton } from '@/components/features/Applications/ApplicationForm/ApplicationFormExitButton';
import { ApplicationFormProvider } from '@/components/features/Applications/ApplicationForm/ApplicationFormProvider';

const GrantApplyPage = () => (
  <>
    <ApplicationFormProvider storageKey={APPLICATION_STORAGE_KEY}>
      <Header isEmpty>
        <ApplicationFormExitButton />
      </Header>
      <Main>
        <ApplicationFormContent />
      </Main>
    </ApplicationFormProvider>
  </>
);

export default GrantApplyPage;
